import { createFileRoute } from '@tanstack/react-router'
import { TrainersAssignPage } from '@/features/trainers'

export const Route = createFileRoute('/_authenticated/trainers/assign')({
  component: TrainersAssignPage,
})
